"use client";

import type { ReactNode } from "react";
import { useEffect, useRef, useState } from "react";

type Props = { children: ReactNode; className?: string; delayMs?: number };

/** Subtle scroll-in; disabled when prefers-reduced-motion. */
export function ScrollReveal({ children, className = "", delayMs = 0 }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const [on, setOn] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  });

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e?.isIntersecting) {
          setOn(true);
          io.disconnect();
        }
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.08 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`ed-scroll-reveal ${on ? "ed-scroll-reveal--in" : ""} ${className}`}
      style={{ ["--ed-sr-delay" as string]: `${delayMs}ms` }}
    >
      {children}
    </div>
  );
}
